export default {
  toasts: {
    auth_token_invalid: 'Auth-Token ungültig',
    host_access_refused:
      'Diese Adresse gehört zu einem Partner, zu dem Ihr Konto nicht gehört. Melden Sie sich unter Ihrer eigenen Adresse an.',
  },
};
